export const SPECIAL_MESSAGE_SET_IS_LOADING = 'SPECIAL_MESSAGE_SET_IS_LOADING';

export const SPECIAL_MESSAGE_REPORT_LOAD = 'SPECIAL_MESSAGE_REPORT_LOAD';

export const GET_SPECIAL_MESSAGE_REPORT = 'GET_SPECIAL_MESSAGE_REPORT';
export const GET_SPECIAL_MESSAGE_REPORT_ERROR =
  'GET_SPECIAL_MESSAGE_REPORT_ERROR';

export const CLEAR_REPORT_DATA = 'CLEAR_REPORT_DATA';



// WEBPACK FOOTER //
// ./src/pages/specialmessage/state/types.js